import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    sourceUrl: '',
    skin: {},
    battlefield2042UserName:'',
    order:'kills'
  },
  mutations: {
    setStateData(state, option) {
      state[option.state] = option.data;
    }
  },
  actions: {},
  modules: {}
})